import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
    connect() {
        // Close/reset modal form after a successful submit.
        this._onSubmitEnd = (event) => {
            if (!this.successfulSubmission(event)) return
            this.resetFormControls()
            this.closeModal()
        }
        this._onAjaxSuccess = () => {
            this.resetFormControls()
            this.closeModal()
        }

        this.element.addEventListener("turbo:submit-end", this._onSubmitEnd)
        this.element.addEventListener("ajax:success", this._onAjaxSuccess)
    }

    disconnect() {
        this.element.removeEventListener("turbo:submit-end", this._onSubmitEnd)
        this.element.removeEventListener("ajax:success", this._onAjaxSuccess)
    }

    reset(event) {
        if (!this.successfulSubmission(event)) return
        this.resetFormControls()
        this.closeModal()
    }

    closeModal() {
        const modalEl = this.element.closest(".modal")
        if (!modalEl) return

        // clear focus to avoid stuck focus ring/ARIA issues
        if (document.activeElement && modalEl.contains(document.activeElement)) {
            document.activeElement.blur()
        }

        const cleanup = () => {
            if (document.querySelector(".modal.show")) return
            document.querySelectorAll(".modal-backdrop").forEach((el) => el.remove())
            document.body.classList.remove("modal-open")
            document.body.style.removeProperty("padding-right")
            document.body.style.removeProperty("overflow")
        }

        const instance = bootstrap.Modal.getInstance(modalEl) || bootstrap.Modal.getOrCreateInstance(modalEl)
        modalEl.addEventListener("hidden.bs.modal", cleanup, { once: true })
        instance.hide()
        setTimeout(cleanup, 180)
    }

    successfulSubmission(event) {
        if (!event) return true

        if (typeof event.detail?.success === "boolean") return event.detail.success

        const fetchResponse = event?.detail?.fetchResponse
        if (typeof fetchResponse?.succeeded === "boolean") return fetchResponse.succeeded

        const status = fetchResponse?.statusCode || fetchResponse?.status
        if (typeof status === "number") return status >= 200 && status < 300

        return true
    }

    resetFormControls() {
        if (this.element instanceof HTMLFormElement) {
            this.element.reset()
            return
        }

        const form = this.element.querySelector("form")
        if (form) form.reset()
    }
}
